// extracted by mini-css-extract-plugin
export default {"treeSelectWrapper":"index_treeSelectWrapper__rapSl","treeSelectDropdown":"index_treeSelectDropdown__pZ-hD"};